import { Component, OnInit, Input } from '@angular/core';

export interface Clinicas {
  name: string;
  address: string;
  hours: string;
}

export interface UnidadesClinicaData {
  title: string;
  clinicas: Array<Clinicas>;
}

@Component({
  selector: 'fcp-unidades-clinica',
  templateUrl: './unidades-clinica.component.html',
  styleUrls: ['./unidades-clinica.component.scss']
})
export class UnidadesClinicaComponent implements OnInit {

  @Input() public unidadesClinica: UnidadesClinicaData;

  constructor() { }

  ngOnInit(): void {
  }

}
